import { render } from "./CaseMessages.vue?vue&type=template&id=1aaa227f"
import script from "./CaseMessages.vue?vue&type=script&lang=js"
export * from "./CaseMessages.vue?vue&type=script&lang=js"

import "./CaseMessages.vue?vue&type=style&index=0&id=1aaa227f&lang=css"

import exportComponent from "/codebuild/output/src1815703633/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__